import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import ScrollToTop from "./ScrollToTop";
import { Toaster } from "sonner";

const TOAST_OPTIONS = {
  style: {
    background: "#151515",
    color: "#fff",
    border: "1px solid rgba(124,255,0,0.4)",
    borderRadius: 0,
    fontFamily: "Oswald, sans-serif",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
  },
};

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      {/* SVG filter moved to App.js so it covers LoadingScreen as well */}
      <Navbar />
      <main className="pt-20 md:pt-24" data-testid="page-main">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
      <ScrollToTop />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={TOAST_OPTIONS}
      />
    </div>
  );
}
